<template>
    <div v-if="dataTree">
        <DecisionTree :data-tree="dataTree" />
    </div>
</template>

<script setup>
import DecisionTree from '@/best-fare-students/components/DecisionTree';

defineProps({
    dataTree: {
        type: Object,
        default: null
    }
});
</script>

<style lang="scss">
.vue-app-best-fare-students {
    margin: 24px 0;
}
</style>
